/**
 * ระบบ NPC (Non-Player Characters)
 *
 * บริหารข้อมูล NPC ตำแหน่งประจำจุดในแต่ละโซน และบทสนทนา
 * ใช้งานร่วมกันทั้ง Client และ Server
 */
import npcsJson from "./data/npcs.json" with { type: "json" };
export const NPC_LIST = npcsJson;
export const NPCS = Object.fromEntries(NPC_LIST.map((n) => [n.id, n]));
/** ระยะห่างสูงสุดในการพูดคุยกับ NPC (หน่วยโลก) */
export const NPC_INTERACT_RANGE = 3.5;
export function getNpc(id) {
    return NPCS[id];
}
export function npcsInZone(zoneId) {
    return NPC_LIST.filter((n) => n.zone === zoneId);
}
//# sourceMappingURL=npcs.js.map